module.exports = __webpack_public_path__ + "static/img/social-doctor-logo.5243e4b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/social-doctor-logo.svg
// module id = 8gb9
// module chunks = 0